<template>
    <div>
        <!--<component :is="selectedPara"></component>-->
        
    </div>
    <div id="container-component">
        <div id="container-parametre">
            <span @click="changeSelectedPara(getIdByTitle(para.title))"  class="parametre-item" v-for="para in lesPara" :id="getIdByTitle(para.title)">{{para.title}}</span>
        </div>
        <div id="container-card" style="width: 90%;">
            <component  :is="'Parametre'+selectedPara"></component>
        </div>
    </div>
</template>
<style scoped>
    *{
        margin:0;
        padding:0;
    }
    #container-component {
        display: flex;
        flex-direction: row;
        align-items: start;
        /*border: 0.1px solid;*/
    }
    #container-parametre {
        display: flex;
        flex-direction: column;
        justify-content: center;
        top:0;
    }
    .parametre-item{
        height: 50px;
        width: 10rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .parametre-item:hover {
            cursor: pointer;
            background: linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB);
            color: white;
    }
    .selected-parametre-item {
        background: linear-gradient(144deg,#AF40FF, #5B42F3 50%,#00DDEB);
        color: white;
    }
    .container-card{
        display: flex;
        width: 100%;
    }
</style>
<script>
    import { defineComponent } from 'vue';
    import ParametreGeneral from './ParametreGeneral.vue';
    import ParametreFacture from './ParametreFacture.vue';
    import ParametrePracticien from './ParametrePraticien.vue';
    import ParametreLienAg2035 from './ParametreLienAg2035.vue';
    import ParametreLienFisimed from './ParametreLienFisimed.vue';
    import ParametreDivers from './ParametreDivers.vue';
    import ParametreParametres from './ParametreParametres.vue';
    import ParametreSauvegarde from './ParametreSauvegarde.vue';// Parametre
    import ParametreGestionTiersPayant from './ParametreGestionTiersPayant.vue';
    import ParametreDroitsADRI from './ParametreDroitsADRI.vue';
    export default defineComponent({
        components: {
            //Les composants
            ParametreGeneral,
            ParametreFacture,
            ParametrePracticien,
            ParametreLienAg2035,
            ParametreLienFisimed,
            ParametreDivers,
            ParametreParametres,
            ParametreSauvegarde,
            ParametreGestionTiersPayant,
            ParametreDroitsADRI
        },
        data: function () {
            return {
                message: 'Hello world',
                appliqueTarifOutreMer: false,
                selectedPara: "General",
                lesPara: [
                    { title: "Général", id: "General" },
                    { title: "Facture", id: "Facture" },
                    { title: "Practicien", id: "Practicien" },
                    { title: "Lien Ag2035", id: this.remplacerEspaceParTrait("Lien Ag2035") },
                    { title: "Lien Fisimed", id: this.remplacerEspaceParTrait("Lien Fisimed") },
                    { title: "Divers", id: "Divers" },
                    { title: "Paramètres", id: this.removeAccents("Paramètres") },
                    { title: "Sauvegarde", id: "Sauvegarde" },
                    { title: "Gestion Tiers Payant", id: this.remplacerEspaceParTrait("Gestion Tiers Payant") },
                    { title: "Droits ADRI", id: this.remplacerEspaceParTrait("Droits ADRI") },
                ],
            }
        },

        computed: {

        },

        methods: {
            changeSelectedPara(para) {
                this.selectedPara = para; 
            },
            getIdByTitle(title) {
                const id = this.removeAccents(this.supprimerEspaces(title));
                return id;
            },
            supprimerEspaces(chaine) {
                return chaine.replace(/\s/g, '');
            },
            remplacerEspaceParTrait(chaine) {
                return chaine.replace(/\s/g, '-');
            },
            removeAccents(str) {
                return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            }
        },
        props: ["parametreComposant"],
        mounted() {
            if (this.parametreComposant == undefined) {
                this.$router.push({ name: "ParametreWithComponent", params: { parametreComposant: "General" } });
                this.selectedPara = "General"
            }
            else {
                this.selectedPara = this.parametreComposant
            }
        }
        ,
        created() {
        },
        watch: {
            selectedPara(newValue, oldValue) {
                //console.log(`newValue=${newValue} et oldValue=${oldValue}`);
                console.log(newValue);
                if (newValue == undefined) {
                    document.getElementById(newValue).classList.add("selected-parametre-item");
                }
                else {
                    this.$router.push({ name: "ParametreWithComponent", params: { parametreComposant: newValue } });
                    document.getElementById(oldValue).classList.remove("selected-parametre-item");
                    document.getElementById(newValue).classList.add("selected-parametre-item");
                }
                console.log(document.getElementById(newValue));
            }
        }

    });
</script>